<template>
  <BaseLayout
    v-bind="$attrs"
    v-on="$listeners"
    :disableFooter="true"
    :styleConfig="styleConfig"
  >
    <template v-slot:header>
      <TheHeaderPrimary
        :navigationItems="getNavigationItems"
        :tenant="tenant"
        :tenantUser="tenantUser"
        :userDropdownOptions="getUserDropdownOptions"
        :windowWidth="windowWidth"
      />
    </template>
    <template v-slot:container>
      <slot />
    </template>
  </BaseLayout>
</template>

<script>
  import BaseLayout from '@base/v2/base-layout'
  import TheHeaderPrimary from '@modules/v2/layout/the-header-primary'
  import { Layout } from '@js/styles'
  import { mapGetters, mapState } from 'vuex'
  import { MODAL_WINDOW_NAMES, Z_INDEXES } from '@js/constants'

  export default {
    name: 'LayoutPrimary',
    inheritAttrs: false,
    components: {
      BaseLayout,
      TheHeaderPrimary,
    },
    data: function () {
      return {
        styleConfig: {
          container: {
            alignItems: 'center',
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'flex-start',
            width: '100%',
          },
          footer: {},
          header: {
            alignItems: 'center',
            boxSizing: 'border-box',
            display: 'flex',
            height: '64px',
            width: '100%',
            zIndex: Z_INDEXES.LAYOUT.HEADER,
          },
          root: {},
        },
      };
    },
    computed: {
      ...mapGetters('tenant', ['isEnterprise',]),
      ...mapGetters('tenantUser', ['isAdmin',]),
      ...mapState({
        tenant: state => state.tenant,
        tenantUser: state => state.tenantUser,
        windowWidth: state => state.window.width,
      }),
      getNavigationItems: function () {
        const items = [
          {
            id: 'home',
            label: 'Home',
            to: {
              name: 'private-home',
            },
            onClick: () => {},
            selectedFunction: function (routePath) {
              return routePath === '/';
            },
          },
          {
            id: 'teamup',
            label: 'Team-Up',
            to: {
              name: 'teamup-select',
            },
            onClick: () => {},
            selectedFunction: function (routePath) {
              return routePath.startsWith('/teamup');
            },
          },
        ].concat(this.isAdmin ? [
          {
            id: 'survey',
            label: 'Survey',
            locked: !this.isEnterprise,
            to: this.isEnterprise
              ? {
                  name: 'admin-surveys',
                }
              : null,
            onClick: this.isEnterprise
              ? () => {}
              : () => {
                const params = {
                  functionName: 'Survey',
                  description: "With Survey, you can assess your team's essential skills.",
                };
                this.$modal.show(MODAL_WINDOW_NAMES.INTRODUCE_ENTERPRISE_LICENSE_PRIMARY, params);
              },
            selectedFunction: function (routePath) {
              return routePath.startsWith('/admin/surveys');
            },
          },
        ] : []);
        return items;
      },
      getUserDropdownOptions: function () {
        return (
          [
            {
              id: 1,
              label: 'View my page',
              adminRequired: false,
              locked: false,
              hookFunction: () => {
                if (
                  this.$route.name !== 'user' ||
                  parseInt(this.$route.params?.id) !== parseInt(this.tenantUser.id)
                ) {
                  this.$router.push({
                    name: 'user',
                    params: {
                      id: this.tenantUser.id,
                    },
                  });
                } else {
                  location.reload();
                }
              },
            },
            {
              id: 2,
              label: 'Invite coworkers',
              adminRequired: true,
              locked: false,
              hookFunction: () => {
                const params = {
                  tenant: this.tenant,
                };
                this.$modal.show(MODAL_WINDOW_NAMES.INVITE_TO_TENANT_PRIMARY, params);
              },
            },
            {
              id: 3,
              label: 'Settings',
              adminRequired: false,
              locked: false,
              hookFunction: () => {
                if (this.$route.name !== 'settings') {
                  this.$router.push({
                    name: 'settings'
                  });
                }
              },
            },
            {
              id: 4,
              label: 'Help',
              adminRequired: false,
              locked: false,
              hookFunction: () => {
                this.$modal.show(MODAL_WINDOW_NAMES.HELP_PRIMARY);
              },
            },
            {
              id: 5,
              label: 'Switch workspace',
              adminRequired: false,
              locked: false,
              hookFunction: () => {
                this.$store.commit('tenant/initialize');
              },
            },
            {
              id: 6,
              label: 'Log out',
              adminRequired: false,
              locked: false,
              hookFunction: () => {
                this.$store.commit('auth/clearRefreshToken');
              },
            },
        ]).filter(elem => !elem.adminRequired || this.isAdmin);
      },
    },
  };
</script>
